import { trpc } from "@/lib/trpc";
import { formatBJ } from "@/lib/timeUtils";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { History } from "lucide-react";
import { ExportButton } from "@/components/ExportButton";

export default function Records() {
  const { data: records, isLoading } = trpc.records.list.useQuery();

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-xl font-bold flex items-center gap-2">
            <History className="h-5 w-5 text-primary" />
            交易记录
          </h1>
          <p className="text-sm text-muted-foreground mt-1">查看所有历史交易记录</p>
        </div>
        <ExportButton />
      </div>

      <Card className="bg-card border-border/50">
        <CardHeader className="pb-3">
          <CardTitle className="text-sm font-medium">
            历史记录 ({records?.length || 0} 条)
          </CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          {records && records.length > 0 ? (
            <div className="overflow-x-auto">
              <Table>
                <TableHeader>
                  <TableRow className="border-border/50">
                    <TableHead className="text-xs">时间</TableHead>
                    <TableHead className="text-xs">代码</TableHead>
                    <TableHead className="text-xs">名称</TableHead>
                    <TableHead className="text-xs">方向</TableHead>
                    <TableHead className="text-xs text-right">价格</TableHead>
                    <TableHead className="text-xs text-right">数量</TableHead>
                    <TableHead className="text-xs text-right">交易金额</TableHead>
                    <TableHead className="text-xs text-right">手续费</TableHead>
                    <TableHead className="text-xs text-right">盈亏</TableHead>
                    <TableHead className="text-xs text-right">净利率%</TableHead>
                    <TableHead className="text-xs">模式</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {records.map((r) => (
                    <TableRow key={r.id} className="border-border/30">
                      <TableCell className="text-xs text-muted-foreground">
                        {formatBJ(r.createdAt, "datetime")}
                      </TableCell>
                      <TableCell className="text-xs font-mono">{r.stockCode}</TableCell>
                      <TableCell className="text-xs">{r.stockName}</TableCell>
                      <TableCell>
                        <Badge className={`text-[10px] ${r.direction === "buy" ? "bg-gain text-gain" : "bg-loss text-loss"}`}>
                          {r.direction === "buy" ? "买入" : "卖出"}
                        </Badge>
                      </TableCell>
                      <TableCell className="text-xs text-right font-mono">{r.price.toFixed(2)}</TableCell>
                      <TableCell className="text-xs text-right">{r.quantity}</TableCell>
                      <TableCell className="text-xs text-right font-mono">¥{r.amount.toFixed(0)}</TableCell>
                      <TableCell className="text-xs text-right text-muted-foreground">{r.fee.toFixed(2)}</TableCell>
                      <TableCell className={`text-xs text-right ${r.profitLoss >= 0 ? "text-gain" : "text-loss"}`}>
                        {r.profitLoss >= 0 ? "+" : ""}{r.profitLoss.toFixed(0)}
                      </TableCell>
                      <TableCell className={`text-xs text-right font-mono ${(r as any).profitLossPct >= 0 ? "text-gain" : "text-loss"}`}>
                        {(r as any).profitLossPct >= 0 ? "+" : ""}{Number((r as any).profitLossPct || 0).toFixed(3)}%
                      </TableCell>
                      <TableCell>
                        <Badge variant={r.isDryRun === 1 ? "outline" : "default"} className="text-[10px]">
                          {r.isDryRun === 1 ? "模拟" : "实盘"}
                        </Badge>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-16 text-muted-foreground">
              <History className="h-10 w-10 mb-3 opacity-30" />
              <p className="text-sm">{isLoading ? "加载中..." : "暂无交易记录"}</p>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
